import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import {
  fundLockedCaption,
  notVisibleToClientCaption,
  professionalInvestorCaption,
  qualifiedInvestorCaption,
} from '../../../AssetCaptions/constants';
import {
  closedToApplicationDescriptionFilter,
  getRiskRatingLevelFilter,
  isInvestorFilter,
  quotationRedemptionOrLiquidityTermFilter,
  applicationAmountFilter,
  redemptionDaysFilter,
} from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { FundsAsset } from '.';

const fundsCaptions: AssetCaptionType[] = [
  qualifiedInvestorCaption,
  professionalInvestorCaption,
  fundLockedCaption,
  notVisibleToClientCaption,
];

export const fundsTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Produto', orderValue: 'productName', flex: 3 },
  { title: 'Tipo', orderValue: 'productCategory', flex: 2 },
  { title: 'Rent. 12 meses', orderValue: 'profitabilityTwelveMonths', flex: 2 },
  { title: 'Taxa admin.', orderValue: 'administrationFee', flex: 2 },
  { title: 'Resgate', orderValue: 'quotationRedemptionTerm', flex: 2 },
  { title: 'Risco', orderValue: 'riskRatingLevel', flex: 2 },
  { title: 'Valor a aplicar', flex: 3 },
  { title: '', flex: 2 },
];

export const fundsConstants = {
  id: 'funds',
  typeGetterId: 'funds',
  title: 'Fundos',
  operationId: 1,
  operationName: 'Aplicar',
  operationType: 'buy' as OperationType,
  color: 'product.fundos' as ColorTypes.Option,
  principalComponent: FundsAsset,
  tableHead: fundsTableHead,
  hideTableHead: false,
  marketStatusSelector: emptyMarketStatusQuery,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      getRiskRatingLevelFilter('funds'),
      ...transformCustomFilters(customFilters),
      isInvestorFilter,
      closedToApplicationDescriptionFilter,
      quotationRedemptionOrLiquidityTermFilter,
      applicationAmountFilter,
      redemptionDaysFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'productCategory',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'productCategory'),
  captions: fundsCaptions,
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: '',
  unleashFlagBatchTicket: Constant.UnleashBasketFundsToggle,
  unleashFlagCustomers: Constant.UnleashCustomersFundsToggle,
} as const;
